import { render, staticRenderFns } from "./ccb-tree-menu.vue?vue&type=template&id=50f65bfe&scoped=true&"
import script from "./ccb-tree-menu.vue?vue&type=script&lang=js&"
export * from "./ccb-tree-menu.vue?vue&type=script&lang=js&"
import style0 from "./ccb-tree-menu.vue?vue&type=style&index=0&id=50f65bfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f65bfe",
  null
  
)

export default component.exports